import React, {useContext, useState} from 'react';
import Swal from "sweetalert2";
import ValidateCpf from "../../../../../components/validation/validate-cpf.jsx";
import {AgentContext} from "../context/agent-context.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";
import {validateExistsCpf} from "./exists-cpf.js";

const CpfModal = ({id, noCpfJustificationRequiredLength}) => {
    const [isValid, setIsValid] = useState(true);
    const {user, setUser, openCpfModal, setOpenCpfModal, setExistsCpf} = useContext(AgentContext)

    const [state, setState] = useState("");
    const [errorMessage, setErrorMessage] = useState(undefined);

    const closeModal = async (withoutCpf) => {
        if (!withoutCpf) {
            if (!state) {
                setErrorMessage("Informe um CPF.")
                return
            }

            if (!isValid || state.length < 14) {
                setErrorMessage("Informe um CPF válido.")
                return
            }

            const ok = await validateExistsCpf(state, id);

            if (ok) {
                setUser(prev => ({...prev, general: {... user.general, cpf: state}}))
                setOpenCpfModal(false);
                setExistsCpf(true);
            }

            return
        }

        setOpenCpfModal(false);

        Swal.fire({
            title: "Atenção",
            text: "Informar o CPF é fundamental para garantir a segurança e autenticidade dos dados. Evita duplicidades, fraudes e permite maior confiabilidade no sistema.",
            icon: "warning",
            input: "textarea",
            inputLabel: "Justificativa para adicionar agente sem CPF:",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Retornar",
            showCancelButton: true,
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm(inputValue) {
                if (!inputValue) {
                    Swal.showValidationMessage("Escreva uma justificativa!");
                    return;
                }

                if (inputValue.trim().length < noCpfJustificationRequiredLength) {
                    Swal.showValidationMessage("A justificativa deve ter no mínimo " + noCpfJustificationRequiredLength + " caracteres.");
                }
            }
        }).then(({isConfirmed, isDismissed, value}) => {
            if (isDismissed) setOpenCpfModal(true);

            if (isConfirmed) {
                setUser(prev => ({...prev, general: {... user.general, noCpfJustification: value}}))
            }
        });
    }

    const handleCPF = ({target: {value}}) => {
        if (value.length === 14) ValidateCpf(value, setIsValid);

        setState(value);
    }

    return (
        <Modal
            open={openCpfModal}
            setOpen={() => setOpenCpfModal(false)}
            centered
            backdrop="static"
            keyboard={false}
            title={"Digite o CPF"}
            className={"w-3/12"}
            isCloseClick={false}
            showCloseButton={false}
        >
            <Modal.Body className={"p-4"}>
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 relative">
                        <InputForm
                            label="CPF"
                            value={state}
                            inputClass={isValid ? "" : "!text-[#dc4c64] !border-[#dc4c64]"}
                            labelClass={isValid ? "" : "!text-[#dc4c64]"}
                            onChange={handleCPF}
                            onBlur={handleCPF}
                            mask={'000.000.000-00'} />
                        {
                            !isValid &&
                            <>
                                <small className={"text-[#dc4c64] absolute top-[-14px] right-0"}>CPF inválido</small>
                                <FaTriangleExclamation color={"#dc4c64"} className={"absolute top-[9px] right-[10px]"} />
                            </>
                        }
                    </div>
                </div>

                {
                    !!errorMessage &&
                    <div className="flex items-center gap-1 mt-1">
                        <FaCircleExclamation color={"#f27474"} /> {errorMessage}
                    </div>
                }
            </Modal.Body>

            <Modal.Footer>
                <div className={"w-full flex gap-2 justify-end"}>
                    <Button target="secondary" onClick={() => closeModal(true)}>
                        Sem CPF
                    </Button>
                    <Button onClick={() => closeModal(false)}>
                        Ok
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CpfModal;